import { FormattedMessage } from "react-intl";
import { Skeleton, Text } from "@lendcord/concord";

interface ProfileFieldProps {
  labelId: string;
  value: string;
  valueClassName?: string;
  // Swaps value for a skeleton sized to Text size="sm"'s line-height (20px,
  // h-5) — same footprint, no reflow. See docs/design-system.md's "Loading
  // states" section.
  loading?: boolean;
}

export function ProfileField({ labelId, value, valueClassName = "", loading = false }: ProfileFieldProps) {
  return (
    <div>
      <Text as="p" size="xs" variant="muted">
        <FormattedMessage id={labelId} />
      </Text>
      {loading ? (
        <Skeleton variant="text" className="mt-1 h-5 w-24" />
      ) : (
        <Text as="p" size="sm" className={`mt-0.5 font-medium ${valueClassName}`.trim()}>
          {value}
        </Text>
      )}
    </div>
  );
}
